import { render } from "./partial-skip-navigation-link.vue?vue&type=template&id=506df465&ts=true"
import script from "./partial-skip-navigation-link.vue?vue&type=script&lang=ts"
export * from "./partial-skip-navigation-link.vue?vue&type=script&lang=ts"

import "./partial-skip-navigation-link.vue?vue&type=style&index=0&id=506df465&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__